/*==============================================================================
  ___  _   _    _
 /   || | | |  | |
 \__  | | | |  | |  __
 /    |/  |/_) |/  /  \_/\/
 \___/|__/| \_/|__/\__/  /\_/
               |\
               |/
  Concrete v0.1
  https://elkfox.com
  https://experts.shopify.com/elkfox
  Copyright 2015 Shopify Inc. & Elkfox Co Pty Ltd
==============================================================================*/

$(document).ready(function() {

  $('.theme-header [data-action="search"]').click(function(event) {
    var form = $(this).data('target');
    $(form + ' .focus').select();
  });

  $('.dropdown-link[data-collection-hover]').hover(function() {
    var collection = $(this).data('collection-hover');
    $('.dropdown-image[data-collection="' + collection + '"]').addClass('active');
  }, function(){
    var collection = $(this).data('collection-hover');
    $('.dropdown-image[data-collection="' + collection + '"]').removeClass('active');
  });

  $('[data-action="toggle"]').click(function(event) {
    event.preventDefault();
    var dropdown = $(this).data('target');
    $(dropdown).toggleClass('active');
    $(this).toggleClass('active-toggle');
  });

  $('[data-target="#PopupBlog"]').click(function(event) {
    var image = $(this).data('image')
        caption = $(this).siblings('p')
        target = $(this).data('target');
    $(target + ' #PopupBlogImage').css('background-image', 'url(' + image + ')');
    $(target + ' #PopupBlogCaption').html(caption.html());
  });

});
